import { Component, Input, Output, EventEmitter, ViewChild, AfterViewInit, HostListener } from '@angular/core';
import { WidgetsHelper } from '../widgets.helper';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'interface-widget-configurator',
  template: `<form #form="ngForm" (ngSubmit)="saveConfiguration(form.value)">
  <div class="close-button" (click)="close()">
    <i class="fa fa-times"></i>
  </div>
  <div class="info-block">
    <div class="container">
      <h5 class="pt-2">Configuration</h5>
    </div>
    <hr class="mb-0">
  </div>
  <div class="container main">
    <div class="config" *ngFor="let config of item?.meta?.configuration">
      <label [attr.for]="config.key">{{ config.name }}: </label>
      <ng-container [ngSwitch]="config.type">
        <ng-container *ngSwitchCase="'select'">
          <select [attr.id]="config.key" class="form-control" [name]="config.key" ngModel>
            <option *ngFor="let option of config.options || customOptions(config)" [innerHtml]="option"></option>
          </select>
        </ng-container>
        <ng-container *ngSwitchCase="'textarea'">
          <textarea [attr.id]="config.key" class="form-control" [placeholder]="config.placeholder || config.name" [name]="config.key"
            ngModel></textarea>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <input [attr.id]="config.key" class="form-control" type="text" [placeholder]="config.placeholder || config.name"
            [name]="config.key" ngModel>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <div class="info-block footer">
    <button class="btn btn-primary" type="submit">Save</button>
  </div>
</form>
`,
  styles: [`:host{min-width:350px;width:350px;max-width:350px;float:right;background-color:#fff;border-left:1px solid #ccc;z-index:114;height:100%;position:relative}.info-block{max-height:35px}.main{margin-top:15px;max-height:calc('100%'- 105px);overflow-y:auto}.footer{position:absolute;bottom:10px;left:10px;max-width:calc('100%'- 10px)}.close-button{position:absolute;top:0;right:15px}`],
})
export class WidgetConfiguratorComponent implements AfterViewInit {
  @Input('item') item: any;
  @Output('onSave') saveEmitter = new EventEmitter<any>();
  @Output('onClose') closeEmitter = new EventEmitter<any>();
  @ViewChild('form') form: FormGroup;

  constructor() { }

  ngAfterViewInit() {
    setTimeout(() => {
      const formData = {};
      const values = Object.assign({}, this.values, this.values.meta);
      Object.keys(this.form.controls).forEach((key) => {
        formData[key] = values[key] || '';
      });
      this.form.setValue(formData);
    }, 1);
  }

  get values() {
    return this.item ? WidgetsHelper.sanizeConfig(this.item, true) : {};
  }

  @HostListener('document:keydown.escape') onKeydownHandler() {
    this.close();
  }

  customOptions(config) {
    let options = [];
    if (config.key === 'size') {
      options = WidgetsHelper.generateSizeOptions(this.item.meta.options);
    }
    return options;
  }

  saveConfiguration(formData: Object) {
    this.saveEmitter.emit(Object.assign({}, this.item, { meta: Object.assign({}, this.item.meta, formData) }));
  }

  close() {
    this.closeEmitter.emit();
  }
}
